import { MealItemModel } from "./meal-item.factory";
import { MealPlanModel } from "./meal-plan.factory";
import { MealModel } from "./meal.factory";
import { ImageModel } from "./image.factory";
import { MealPlanDayModel } from "./meal-plan-day.factory";
import { RecipeModel } from "./recipe.factory";
import { TestModel } from "./test.factory";
import { AuthModel } from "./auth.factory";
import { CurrentUserModel } from "./current-user.factory";
import { CheckinModel } from "./checkin.factory";
import { UserMealPlanModel } from "./user-meal-plan.factory";
import { UserSubscriptionModel } from "./subscription.factory";
import { UserSubscriptionPlanModel } from "./subscription-plan.factory";
import { MetabolicTypeModel } from "./metabolic-type.factory";
import { WeightClassModel } from "./weight-class.factory";
import { MealRecipeIngredientModel } from "./meal-recipe-ingredient.factory";
import { TagModel } from "./tag.factory";
import { FoodSearchModel } from "./food-search.factory";
import { RecommendedRecipeModel } from "./recommended-recipe.factory";
import { MiscModel } from "./misc.factory";
import { LoggedMealModel } from "./logged-meal.factory";
import { LoggedMealItemModel } from "./logged-meal-item.factory";
import { WaterTrackerModel } from "./water-tracker.factory";
import { ExerciseTrackerModel } from "./exercise-tracker.factory";
import { ExerciseModel } from "./exercise.factory";
import { LoggedExerciseModel } from "./logged-exercise.factory";
import { TipModel } from "./tip.factory";
import { FoodModel } from "./food.factory";
import { UserMealItemModel } from "./user-meal-item.factory";
import { MealRecipeModel } from "./meal-recipe.factory";
import { ContentModel } from "./content.factory";
import { PdfModel } from "./pdf.factory";
import { CheckinImageModel } from "./checkin-image.factory";
import { FavoriteRecipeModel } from "./favorite-recipe.factory";
import { AccountImageModel } from "./account-image.factory";
import { CustomRecipeModel } from "./custom-recipe.factory";

export var dataModelsModule = angular.
module('gplans.core.models', ['gplans.config']).
config(["$modelFactoryProvider", "gplansConf", function ($modelFactoryProvider, gplansConf) {
  "ngInject";
  $modelFactoryProvider.defaultOptions.stripTrailingSlashes = false;
  // $modelFactoryProvider.defaultOptions.prefix = gplansConf.API_URL;
}]).
factory('TestModel', TestModel).
factory('AuthModel', AuthModel).
factory('CurrentUserModel', CurrentUserModel).
factory('CheckinModel', CheckinModel).
factory('UserMealPlanModel', UserMealPlanModel).
factory('UserSubscriptionModel', UserSubscriptionModel).
factory('UserSubscriptionPlanModel', UserSubscriptionPlanModel).
factory('MealPlanModel', MealPlanModel).
factory('MealPlanDayModel', MealPlanDayModel).
factory('MealModel', MealModel).
factory('MealItemModel', MealItemModel).
factory('UserMealItemModel', UserMealItemModel).
factory('LoggedMealModel', LoggedMealModel).
factory('LoggedMealItemModel', LoggedMealItemModel).
factory('ImageModel', ImageModel).
factory('RecipeModel', RecipeModel).
factory('MealRecipeModel', MealRecipeModel).
factory('MetabolicTypeModel', MetabolicTypeModel).
factory('WeightClassModel', WeightClassModel).
factory('MealRecipeIngredientModel', MealRecipeIngredientModel).
factory('TagModel', TagModel).
factory('FoodSearchModel', FoodSearchModel).
factory('RecommendedRecipeModel', RecommendedRecipeModel).
factory('MiscModel', MiscModel).
factory('WaterTrackerModel', WaterTrackerModel).
factory('ExerciseTrackerModel', ExerciseTrackerModel).
factory('ExerciseModel', ExerciseModel).
factory('LoggedExerciseModel', LoggedExerciseModel).
factory('TipModel', TipModel).
factory('FoodModel', FoodModel).
factory('ContentModel', ContentModel).
factory('PdfModel', PdfModel).
factory('CheckinImageModel', CheckinImageModel).
factory('FavoriteRecipeModel', FavoriteRecipeModel).
factory('AccountImageModel', AccountImageModel).
factory('CustomRecipeModel', CustomRecipeModel);